/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckGeneralError } from './PaxCheckGeneralError';
import {
    PaxCheckGeneralErrorFromJSON,
    PaxCheckGeneralErrorFromJSONTyped,
    PaxCheckGeneralErrorToJSON,
    PaxCheckGeneralErrorToJSONTyped,
} from './PaxCheckGeneralError';

/**
 * 
 * @export
 * @interface PaxCheckErrorContainer
 */
export interface PaxCheckErrorContainer {
    /**
     * 
     * @type {PaxCheckGeneralError}
     * @memberof PaxCheckErrorContainer
     */
    generalError?: PaxCheckGeneralError;
}

/**
 * Check if a given object implements the PaxCheckErrorContainer interface.
 */
export function instanceOfPaxCheckErrorContainer(value: object): value is PaxCheckErrorContainer {
    return true;
}

export function PaxCheckErrorContainerFromJSON(json: any): PaxCheckErrorContainer {
    return PaxCheckErrorContainerFromJSONTyped(json, false);
}

export function PaxCheckErrorContainerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckErrorContainer {
    if (json == null) {
        return json;
    }
    return {
        
        'generalError': json['general_error'] == null ? undefined : PaxCheckGeneralErrorFromJSON(json['general_error']),
    };
}

export function PaxCheckErrorContainerToJSON(json: any): PaxCheckErrorContainer {
    return PaxCheckErrorContainerToJSONTyped(json, false);
}

export function PaxCheckErrorContainerToJSONTyped(value?: PaxCheckErrorContainer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'general_error': PaxCheckGeneralErrorToJSON(value['generalError']),
    };
}

